module.exports = __webpack_public_path__ + "media/images/promotions/cards/fate-nothing-47f141343d4e08f13cc3a42da3a9bdc9.svg";